import { formatCurrency } from '@recargas-dominicanas/core/utils';
import { style } from './finance-item.module.css';

interface Props {
  title: string;
  amount?: number;
}

export function FinanceItem(props: Props) {

  const {
    title,
    amount = 0
  } = props;

  return (
    <div className={style.container}>
      <div className={style.title}>{title}</div>
      <div className={style.amount}>{formatCurrency(amount)}</div>
    </div>
  );
}
